import { put, takeEvery, takeLatest } from "redux-saga/effects";
import axios from "axios";
import { showError } from "../components/commonUtilities";
import {
    GetCurrentUser,
    GET_CURRENT_USER,
    UPDATE_CURRENT_USER_LANGUAGE,
    UpdateCurrentUserLanguageInterface,
    GetConstantsInterface,
    GET_CONSTANTS,
    ConstantsReceivedInterface,
    ReceivedCurrentUser
} from "../actions/User/types";

import { receivedCurrentUser, constantsReceived } from "../actions/User";
import { decrypt } from "../Utilities/decryption";
import { GeneratorYieldType } from "../interfaces/ActionReducer/GetMethod/GetResponse";

function* getCurrentUser(
    action: GetCurrentUser
): Generator<
    Promise<ReceivedCurrentUser> | GeneratorYieldType<ReceivedCurrentUser["payload"]>,
    void,
    ReceivedCurrentUser["payload"]["currentUser"]
> {
    try {
        const json = yield axios
            .get("/api/user/currentuser/", { params: action.payload.params })
            .then((response) => response.data);

        yield put(receivedCurrentUser({ currentUser: json }));
    } catch (e) {
        showError(e);
    }
}

export function* getCurrentUserSaga() {
    yield takeLatest(GET_CURRENT_USER, getCurrentUser);
}

function* updateCurrentUserLanguage(
    action: UpdateCurrentUserLanguageInterface
): Generator<
    Promise<ReceivedCurrentUser> | GeneratorYieldType<ReceivedCurrentUser["payload"]>,
    void,
    ReceivedCurrentUser["payload"]["currentUser"]
> {
    try {
        const json = yield axios
            .post(`/api/user/update_user_language/`, action.payload.data)
            .then((response) => response.data);
        yield put(receivedCurrentUser({ currentUser: json }));
    } catch (e) {
        showError(e);
    }
}

export function* updateCurrentUserLanguageSaga() {
    yield takeEvery(UPDATE_CURRENT_USER_LANGUAGE, updateCurrentUserLanguage);
}

function* getConstants(
    action: GetConstantsInterface
): Generator<
    Promise<ConstantsReceivedInterface> | GeneratorYieldType<ConstantsReceivedInterface["payload"]>,
    void,
    ConstantsReceivedInterface["payload"]["constants"]
> {
    try {
        let json = yield axios
            .get(`/api/misc/constants/`, { params: action.params })
            .then((response) => response.data);

        json = decrypt(json);

        yield put(constantsReceived({ constants: json }));
    } catch (e) {
        showError(e);
    }
}

export function* getConstantsSaga() {
    yield takeLatest(GET_CONSTANTS, getConstants);
}
